<ion-header>
  <ion-toolbar class="header-color">
      <ion-buttons slot="start">
        <ion-back-button defaultHref="search/promotions"></ion-back-button>
      </ion-buttons>
    <ion-title class="title-toolbar">Complete Your Booking</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="padding-horizontal">
          <p class="bold booking-item">Booking Item</p>
          <hr />
          <div class="booking-info">
            <div class="booking-image">
                <ion-img [src]="studio['image'] ? (studio| getImage:'profile') : ''"></ion-img>
            </div>
            <div class="booking-details" *ngIf="studio">
                <h4 class="calm bold text-uppercase title booking-details-title">{{studio?.name | titlecase }}
                </h4>
                <h6>
                  <span class="discount-textu">{{ plan.name }}</span>
                </h6>
                <h2 class="energized bold">
                  <span class="list-amount"> ${{ plan.pivot?.price }} CAD</span>
                </h2>
                <p class="info-location">
                    <svg class="svg-location" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 48c-79.5 0-144 61.39-144 137c0 87 96 224.87 131.25 272.49a15.77 15.77 0 0 0 25.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137Z"/>
                        <circle cx="256" cy="192" r="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
                    </svg>&nbsp;{{ studio?.city | titlecase  }}, {{ studio.province_state?.toUpperCase() }}
                </p>
            </div>
          </div>
          <div class="alert alert-info text-center total-value">
            <p class="bold my-total">
              <span class="total">My Total:</span>&nbsp;
              <span class="tValue">${{ plan.pivot?.price}} CAD</span>&nbsp;
            </p>
          </div>
            <div class="payment-faq">
                <h3>Payment FAQ</h3>
                <div (click)="expandItem(item)" *ngFor="let item of items">
                    <h4>{{item.title}}</h4>
                    <app-expandable [expanded]="item.expanded">
                        <p>{{item.desc}}</p>
                    </app-expandable>
                </div>
            </div>
          <div> 
          <div class="payment-option free-sub">
            <h4 class="bold">Payment</h4>
            <ul class="cc-list">
                <li><span class="visa"></span>
                </li>
                <li><span class="mastercard"></span>
                </li>
                <li><span class="aE"></span>
                </li>
            </ul>
          </div>
          <!-- Saved Card -->
          <div *ngIf="storedCardLast4 && !purchaseData.update_card">
              <div>
                  <div>
                      <img class="reserve-spot-img" src="assets/images/yoga.png" alt="">
                      <p class="reserve-spot-text">Click below to reserve your spot<a target="_blank"> (limited space!)</a> <br></p>
                  </div>
              </div>
              <div class="row">
                  <div>
                      <i class="fa fa-credit-card fa-card"></i> **** **** **** {{storedCardLast4}}
                  </div>
              </div>

              <div>
                  <button class="update-btn" (click)="updateCard()">Update</button>
                  <hr class="grey" />
              </div>
          </div>
          <!-- payment form -->
          <div class="payment-details" [hidden]="storedCardLast4 && !purchaseData.update_card">
              <form action="/" method="post" id="payment-form">
                <!-- <div class="form-row">
                  <div id="card-element"> <!-- a Stripe Element will be inserted here.  </div>
                  <!-- Used to display Element errors
                  <div id="card-errors" role="alert"></div>
                </div> -->
                <p><ion-label>Credit Card Number</ion-label></p>
                <div id="card-number-element"></div>
                <ion-row>
                  <ion-col>
                    <p><ion-label>Expiration</ion-label></p>
                    <div id="card-expiry-element"></div>
                  </ion-col>
                  <ion-col>
                      <p><ion-label>Security</ion-label></p>
                      <div id="card-cvc-element"></div>
                    </ion-col>
                </ion-row>
                <ion-button fill="clear" *ngIf="purchaseData.update_card == true" class="cancel-btn" (click)="cancelUpdateCard()">Cancel update</ion-button>
                <div class="flex mb14 storecard">
                  <ion-checkbox  [(ngModel)]="storeCard" (ionChange)="storeCardChange()" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                  <ion-label>Store my credit card</ion-label>
                </div>

                <div class="outcome">
                  <div class="error"></div>
                  <!-- <div class="success">
                    Success! Your Stripe token is <span class="token"></span>
                  </div> -->
                </div>
              </form>
          </div>

          <ion-row class="data-security">
            <ion-col size="3">
              <div class="dataSafe"></div>
            </ion-col>
            <ion-col size="9">
              <span class="stable">Your data is secure and encrypted</span>
            </ion-col>
          </ion-row>
          </div> 
          <hr />
          <p class="padding-bottom accept-condition">
            By clicking here, I hereby agree to the <a routerLink="/terms-of-use">Terms of Use</a>.
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
      <ion-button expand="full" class="bookingBtn" (click)="completeBooking()">
          Complete Booking
      </ion-button>
  </ion-toolbar>
</ion-footer>
